// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.axios = axios

// https://github.com/Justineo/vue-awesome
// only import the icons you use to reduce bundle size
import 'vue-awesome/icons/refresh'
import 'vue-awesome/icons/arrow-up'
import 'vue-awesome/icons/video-camera'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/pencil'
// import 'vue-awesome/icons/trash'
// import 'vue-awesome/icons/pencil'
// or import all icons if you don't care about bundle size
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'
Vue.component('icon', Icon)

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

Vue.mixin({
  data () {
    return {
      days: 0,
      pageName: ''
    }
  },
  watch: {
    '$route' (to, from) {
      this.pageName = to.name
      // console.log('route change', to, from, to.name, this.pageName)
    }
  },
  methods: {
  },
  created () {
    Date.dateDiff = (datepart, fromdate, todate) => {
      datepart = datepart.toLowerCase()
      var diff = todate - fromdate
      var divideBy = {
        w: 604800000,
        d: 86400000,
        h: 3600000,
        n: 60000,
        s: 1000
      }

      return Math.floor(diff / divideBy[datepart])
    }
    const today = new Date()
    const start = new Date('2017/01/20')
    const end = new Date('2021/01/20')
    const served = Date.dateDiff('d', start, today)
    const left = Date.dateDiff('d', today, end)
    const term = Date.dateDiff('d', start, end)
    this.days = {}
    this.days.served = served
    this.days.remaining = (((served / term)) * 100).toFixed(1)
    this.timer = {
      served,
      left,
      term,
      today,
      start,
      end
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#ftl',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js